import { render, staticRenderFns } from "./saml.vue?vue&type=template&id=c48435fc&scoped=true&"
import script from "./saml.vue?vue&type=script&lang=js&"
export * from "./saml.vue?vue&type=script&lang=js&"
import style0 from "./saml.vue?vue&type=style&index=0&id=c48435fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48435fc",
  null
  
)

export default component.exports